module.exports = "https://health.dajiuxing.com.cn/img/views/binding/img/1.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=views%2Fbinding%2Fimg%2F1.png
// module id = CBil
// module chunks = 93